module.exports = __webpack_public_path__ + "img/firstRE.240652aa.png";